import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { SDUIBannerTextContent } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/SDUIBannerTextContent";
import { BannerImages } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageTextBanner/__internal__/BannerImages";
import { imageTextBannerTextContent, imageTextBannerWrapper, imageTextBannerWrapperLeftVariant, imageTextBannerWrapperRightVariant } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageTextBanner/styles/SDUIImageTextBannerRenderer.css";
import classNames from "classnames";
import React from "react";
export var SDUIDefaultImageTextBannerRenderer = function(props) {
    return /*#__PURE__*/ _jsx(BaseSDUIImageTextBannerRenderer, _object_spread_props(_object_spread({}, props), {
        variant: "left"
    }));
};
export var SDUIImageTextBannerRenderer = function(props) {
    return /*#__PURE__*/ _jsx(BaseSDUIImageTextBannerRenderer, _object_spread_props(_object_spread({}, props), {
        variant: "right"
    }));
};
var BaseSDUIImageTextBannerRenderer = function(param) {
    var bannerComponent = param.bannerComponent, loggingData = param.loggingData, variant = param.variant, renderBehaviour = param.renderBehaviour;
    var images = bannerComponent.images, responsive_images = bannerComponent.responsive_images, style = bannerComponent.style;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(imageTextBannerWrapper, getWrapperVariantClass(variant)),
        style: {
            backgroundColor: getSlateColorToken(style === null || style === void 0 ? void 0 : style.background_color, Decorative.tint.neutral)
        },
        "data-test-id": "image-text-banner-renderer",
        children: [
            /*#__PURE__*/ _jsx(BannerImages, {
                variant: variant,
                images: images,
                responsiveImages: responsive_images,
                renderBehaviour: renderBehaviour
            }),
            /*#__PURE__*/ _jsx(SDUIBannerTextContent, {
                className: imageTextBannerTextContent,
                bannerComponent: bannerComponent,
                loggingData: loggingData
            })
        ]
    });
};
var getWrapperVariantClass = function(variant) {
    switch(variant){
        case "left":
            return imageTextBannerWrapperLeftVariant;
        case "right":
        default:
            return imageTextBannerWrapperRightVariant;
    }
};
